import type { DataAPIEventRow } from '../../masterdependency/framework';

type Props = { items?: DataAPIEventRow[] };

export function DataAPIEventPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.category}-${item.item}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-400">{item.category}: {item.item}</p>
          <div className="mt-2 flex items-center gap-2 text-xs text-slate-500">
            <span className="rounded bg-slate-100 px-2 py-0.5 dark:bg-slate-800">{item.upstream}</span>
            <span>→</span>
            <span className="rounded bg-slate-100 px-2 py-0.5 dark:bg-slate-800">{item.downstream}</span>
            <span className="ml-auto rounded-full bg-emerald-50 px-2 py-0.5 font-medium text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300">
              {item.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
